import React from 'react'

interface TypeContext {
  setPreviousStep: React.Dispatch<React.SetStateAction<number>>
  setStep: React.Dispatch<React.SetStateAction<number>>
  step: number
  previousStep: number
}

export const PickingRouteContext = React.createContext<TypeContext>(
  {} as TypeContext
)
